/**
 * Address actions (DESIGN.md §18) on senders and recipients in the reading pane: a click opens
 * them as a menu (the path without right-click), right-click/Shift+F10/long-press as context menu.
 */
import { defineActions, type ActionRegistry } from '@platform/ui';
import { ClipboardCopyIcon, PencilIcon, UserPlusIcon } from 'lucide-react';
import type { Address } from '../api';

export interface AddressActionHandlers {
  copy(address: Address): void | Promise<void>;
  newMessage(address: Address): void;
}

export function createAddressActions(handlers: AddressActionHandlers): ActionRegistry<Address> {
  const surfaces = ['overflow', 'context'] as const;
  const usable = ({ targets }: { targets: readonly Address[] }) => Boolean(targets[0]?.address);
  return defineActions<Address>([
    {
      id: 'address.copy',
      label: 'webmail.addressActions.copy',
      icon: ClipboardCopyIcon,
      group: 'address',
      surfaces,
      enabled: usable,
      run: ({ targets }) => handlers.copy(targets[0]!),
    },
    {
      id: 'address.newMessage',
      label: 'webmail.addressActions.newMessage',
      icon: PencilIcon,
      group: 'address',
      surfaces,
      enabled: usable,
      run: ({ targets }) => handlers.newMessage(targets[0]!),
    },
    {
      id: 'address.addContact',
      label: 'webmail.addressActions.addContact',
      icon: UserPlusIcon,
      group: 'contacts',
      surfaces,
      // Contacts module (P4) is not built yet.
      planned: true,
      run: () => undefined,
    },
  ]);
}
